/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Empty/view.blocks to change it.
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Empty({
  children,
  viewPath = "/DesignSystem/TasksCreateForm/Actions/Content/LetterNew/Recipients/Empty"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Empty.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="No recipient found for the selected patient"
/>
</div>
{children}
</React.Fragment>)
}